import React from 'react';
import { Sparklines, SparklinesCurve } from 'react-sparklines';
import { dateManagerService } from '../../date-manager/date-manager-service';

export const SparkChartComponent = ({
  dateValueObjs,
  customWidth,
}: {
  dateValueObjs: Record<string, number>;
  customWidth?: string;
}) => {
  const { parseApiDate } = dateManagerService.getInstance();
  const dateSortedEntries = Object.entries(dateValueObjs).sort(
    ([date1], [date2]) =>
      parseApiDate(date1).isAfter(parseApiDate(date2)) ? 1 : -1
  );
  const overTimeValues = dateSortedEntries.map(([, score]) => score);
  return (
    <Sparklines
      style={{ width: customWidth ?? '5vw', fill: 'none' }}
      data={overTimeValues}
    >
      <SparklinesCurve style={{ strokeWidth: 3, fill: 'none' }} color="black" />
    </Sparklines>
  );
};
